class Account {
  public readonly accountAlias: string;
  public readonly accountName: string;
  public readonly lifetouchId: number;
  public readonly zipCodeDisp: string;

  constructor(accountAlias: string, accountName: string, lifetouchId: number, zipCodeDisp: string) {
    this.accountAlias = accountAlias;
    this.accountName = accountName;
    this.lifetouchId = lifetouchId;
    this.zipCodeDisp = zipCodeDisp;
  }

  /**
   * Static factory method to create Account from API response data
   */
  static fromApiData(data: any): Account {
    return new Account(data.accountAlias ?? '', data.accountName ?? '', data.lifetouchId ?? 0, data.zipCodeDisp ?? '');
  }

  /**
   * Static factory method to create multiple Accounts from API response data array
   */
  static fromApiDataArray(dataArray: any[]): Account[] {
    if (!Array.isArray(dataArray)) {
      return [];
    }
    return dataArray.map((data) => Account.fromApiData(data));
  }
}

export default Account;
